<template>
<div class="dropdown-item">
	<slot></slot>
</div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import './../../styles/variables.scss';

.dropdown-item {
	display: flex;
	justify-content: space-between;
	align-items: center;
	min-width: 280px;
	height: 30px;
	padding: 5px;
	border-left: 2px solid transparent;
	transition: all 250ms;
	color: $light-text-color;
	white-space: nowrap;
	cursor: default;

	&:hover {
		border-left: 2px solid $main-blue;
	}

	.dark & {
		color: $dark-grey;
	}
}
</style>
